import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent } from 'react';
import { Grid, GridProps } from '../../grid/Grid/Grid';
import { GridItem } from '../../grid/GridItem/GridItem';
import { FilterPipelineHandle } from '../../hooks/useFilterPipeline/useFilterPipeline';
import { prepareProps } from '../../utils/propUtils';
import { PropsWithoutChildren } from '../../utils/utilityTypes';
import { classes } from '../../utils/utils';
import styles from './FilterBar.module.css';
export type FilterBarProps = PropsWithoutChildren<GridProps> & {
  handle: FilterPipelineHandle;
};
export const FilterBar: FunctionComponent<FilterBarProps> = React.memo(props => {
  const $ = _c(10);
  let T0;
  let t0;
  let t1;
  let t2;
  if ($[0] !== props) {
    const {
      handle,
      className,
      ...remainingProps
    } = prepareProps({
      props,
      ignoreChildren: true
    });
    T0 = Grid;
    t0 = remainingProps;
    t1 = classes(className, styles.container);
    t2 = handle.renderFilters().map(_temp);
    $[0] = props;
    $[1] = T0;
    $[2] = t0;
    $[3] = t1;
    $[4] = t2;
  } else {
    T0 = $[1];
    t0 = $[2];
    t1 = $[3];
    t2 = $[4];
  }
  let t3;
  if ($[5] !== T0 || $[6] !== t0 || $[7] !== t1 || $[8] !== t2) {
    t3 = <T0 {...t0} className={t1}>{t2}</T0>;
    $[5] = T0;
    $[6] = t0;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
});
function _temp(filter) {
  return <GridItem key={filter.id} size={filter.size}>{filter.element}</GridItem>;
}